<template>
  <div class="terms-container">
    <div class="z11 uppercase">TERMS AND CONDITIONS OF USE</div>
    <p class="z11">
      If you log-in to this Web Site or if you use any of the information available on this Web Site, you will
      be deemed to have accepted the terms and conditions of use detailed below.
    </p>

    <p class="z11">
      ARTFIELD KÜLTÜREL DEĞERLER TİCARET ANONİM ŞİRKETİ (“Company”) shall not be held liable for any direct or
      indirect loss or damage arising from breach of contract, tort or other reasons involving logging-in to this
      Web Site and utilization of the Site or information and data available on the Site. The Company will not
      accept any liability for interruptions in the transaction, errors, negligence and power failure arising as
      a result of breach of contract, tort, negligence or other reasons.
    </p>

    <p class="z11">
      The Company reserves the right to change the terms and conditions of use for this Web Site and for all kinds
      of services and products available with the extensions of the Web Site and any information provided on the
      Web Site and to reorganize the Web Site or completely suspend the transmission without any prior notice to the
      relevant users. Such changes shall become effective as of the date of publication on the Web Site. These changes
      will be deemed to have been accepted by the relevant users once they login into the Web Site or utilize the Web
      Site. These terms and conditions of use shall be also valid for the other web pages linked from our Web Site.
    </p>

    <p class="z11">
      The Company will not accept any liability for interruptions in the transaction, errors, negligence, power
      failure, deletion, loss, delays in the transaction or communication, computer viruses, communication failure,
      theft, destruction or unauthorized access to, alteration or utilization of the records arising as a result of
      breach of contract, tort, negligence or other reasons.
    </p>

    <p class="z11">
      This Web Site may contain links and references to the other web sites that are not under the control of the
      Company. The Company is not responsible for the content or other links available on these other web sites.
    </p>

    <p class="z11">
      The Company is the owner or licensee of all materials including but not limited to the general appearance and
      design of this Web Site, all information and images provided on the Web Site, ARTFIELD brand and other trademarks,
      artfield.app domain name, logo, icon, demonstrative, and written, electronic, graphical or machine readable
      technical data, computer software, applicable sales system, business method and business model (“Materials”)
      including those intellectual and industrial property rights applicable thereon and such Materials and rights
      are legally protected.
    </p>

    <p class="z11">
      None of the Materials available on the Web Site, including the code and software may be altered, copied,
      reproduced, transformed into another license, republished, uploaded into another computer, posted, forwarded,
      presented or distributed without the prior consent of the Company and without showing the relevant resource
      used in this process. All parts or certain parts of the Web Site may not be utilized on another web site without
      the prior consent of the Company. Any action taken to the contrary shall be punishable by civil and criminal law.
      All other rights not mentioned herein explicitly are also reserved by the Company.
    </p>

    <p class="z11">
      The Company further reserves the right to update the content of this legal notice page at any time and hereby
      recommends its users to visit the legal notice page every time they log-in into this Web Site.
    </p>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';

onMounted(() => {
  console.log('Terms of Service page loaded.');
});
</script>

<style scoped>
.z11:first-child {
  font-size: 20px;
}
.z11 {
  font-size: 16px;
  font-weight: 400;
  padding: 10px 0;
}

.uppercase {
  text-transform: uppercase;
  margin-top: 20px;
  line-height: 20px;
  letter-spacing: .4px;
}
</style>
